import { Video } from "../../../app/store/types";
import image1 from "../assests/videos/1_chr2_iris3/0.jpg";
import image2 from "../assests/videos/2_chr2_iris3/0.jpg";
import image2_1 from "../assests/videos/2_1_chr2_iris3/0.jpg";
import image11 from "../assests/videos/11_chr2_iris3/0.jpg";
import image22 from "../assests/videos/22_chr2_iris3/0.jpg";

export const sampleVideos: Video[] = [
    {
        id: "1",
        text: "Мы любим божественные качества друг в друге, недостатки любить невозможно.\n\nКонфликты усиливают видение недостатков и ослабляют видение хорошего.\n\nПоэтому для поддержания любви очень важно напоминать себе о возвышенных, положительных качествах близкого человека.",
        audioUrl: "https://www.mfiles.co.uk/mp3-downloads/gs-cd-track2.mp3",
        url: "/videos/1_chr2_iris3.mp4",
        frames: image1,
        duration: 596,
    },
    {
        id: "2",
        text: "Мы любим божественные качества друг в друге, недостатки любить невозможно.\n\nКонфликты усиливают видение недостатков и ослабляют видение хорошего.\n\nПоэтому для поддержания любви очень важно напоминать себе о возвышенных, положительных качествах близкого человека.",
        audioUrl: "https://www.mfiles.co.uk/mp3-downloads/gs-cd-track2.mp3",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
        frames: image2,
        duration: 653,
    },
    {
        id: "3",
        text: "Мы любим божественные качества друг в друге, недостатки любить невозможно.\n\nКонфликты усиливают видение недостатков и ослабляют видение хорошего.\n\nПоэтому для поддержания любви очень важно напоминать себе о возвышенных, положительных качествах близкого человека.",
        audioUrl: "https://www.mfiles.co.uk/mp3-downloads/gs-cd-track2.mp3",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
        frames: image2_1,
        duration: 15,
    },
    {
        id: "4",
        text: "Мы любим божественные качества друг в друге, недостатки любить невозможно.\n\nКонфликты усиливают видение недостатков и ослабляют видение хорошего.\n\nПоэтому для поддержания любви очень важно напоминать себе о возвышенных, положительных качествах близкого человека.",
        audioUrl: "https://www.mfiles.co.uk/mp3-downloads/gs-cd-track2.mp3",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
        frames: image11,

        duration: 15,
    },
    {
        id: "5",
        text: "Мы любим божественные качества друг в друге, недостатки любить невозможно.\n\nКонфликты усиливают видение недостатков и ослабляют видение хорошего.\n\nПоэтому для поддержания любви очень важно напоминать себе о возвышенных, положительных качествах близкого человека.",
        audioUrl: "https://www.mfiles.co.uk/mp3-downloads/gs-cd-track2.mp3",
        url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4",
        frames: image22,
        duration: 60,
    },
];
